import { combineEpics } from 'redux-observable';
import fetchEvents from './fetchEvents';
import fetchEventOptions from './fetchEventOptions';
import fetchEvent from './fetchEvent';
import createEvent from './createEvent';
import deleteEvent from './deleteEvent';
import createIncident from './createIncident';
import realtimeIncidents from './realtimeIncidents';
import editIncident from './editIncident';
import deleteIncident from './deleteIncident';
import editEvent from './editEvent';
import fetchEventMatchScore from './fetchEventMatchScore';
import updateEventMatchScore from './updateEventMatchScore';
import deleteEventMatchScoreEdit from './deleteEventMatchScoreEdit';

export const eventsEpic = combineEpics(
  fetchEvents,
  fetchEventOptions,
  fetchEvent,
  createEvent,
  deleteEvent,
  createIncident,
  realtimeIncidents,
  editIncident,
  deleteIncident,
  editEvent,
  fetchEventMatchScore,
  updateEventMatchScore,
  deleteEventMatchScoreEdit,
);
